import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { Chart } from "react-google-charts";
import ModalPop from 'components/sales/modal/modal';
import FormSection from 'components/sales/formSection/formSectionNew';
import { toast, ToastContainer } from "react-toastify";
import { Button, FormGroup } from 'react-bootstrap';
import './style.css';
import DatePicker from 'components/sales/datePicker/datePicker';
import TableSection from 'components/sales/tableSection/tableSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DivLayout from 'components/sales/divLayout/divLayout';
import Regex from 'services/utils/regex/Regex';
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";

export const options = {
  is3D: true
};

const Dashboard = ({
  getSiteList,
  getInvoiceList,
  dashboardInvoiceListing,
  dashboardSiteListing,
  saveInvoiceData,
  getCSV,
  getLateFee,
  lateFee,
  setInstallmentFee,
  getInvoiceListBySiteNumber,
  dropdownInvoiceListing
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [formModal, setFormModal] = useState(false);
  const [type, setType] = useState("");
  const [user, setUser] = useState({ 'email': '', 'key': 0 })
  const [listData, setListData] = useState([]);
  const [collectionFeeInvoiceList, setCollectionFeeInvoiceList] = useState([]);
  const [remarks, setRemarks] = useState('');
  const [pendingInvoiceView, setPendingInvoiceView] = useState(true);
  const [invoiceNumberListObj, setInvoiceNumberListObj] = useState([]);
  const [multiInvoice, setMultiInvoice] = useState([]);
  const invoiceTypes = ['RENTAL','AMC','ADJUSTED_RENTAL'];
  const COLLECTION_FEE_AMOUNT = 500;
  const inputs = {
    expected_payment_date: null,
    invoice_tagging: null,
    owner_remarks: null,
    type: null,
    invoice_id: null,
    remarkVal: null,
    fee_type: null,
    amount: null,
    remarkFee: null,
    invoice_number: null
  };
  const [formData, setFormData] = useState(inputs);
  const LATE_FEE = "LATE_FEE";
  const COLLECTION_FEE = "COLLECTION_FEE";

  const mapInvoice = [
    "CN", "Legal", "Sales Tagging", "Adjustment for Mapping of Invoices"
  ];

  const pendingInvoicesHeaders = [
    'Business Name',
    'Site Number',
    'Client Name',
    'Invoice Number',
    'Invoice Date',
    'Due Date',
    'Total Amount',
    'Pending Amount',
    'Invoice Document',
    'Expected Date',
    'Map Invoices',
    'Remarks',
    'Action'
  ];

  const myData = [
    ["Projects", "Count per project"]
  ];

  const mySubData = [
    ["Projects", "Count per project"]
  ];

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteList()
      setIsLoading(false);
    })();
  }, []);

  const invoiceList = (email, key, invoiceType = "PENDING") => {
    if(invoiceType === "PAID"){
      setPendingInvoiceView(true);
    }else if(invoiceType === "PENDING"){
      setPendingInvoiceView(true);
    }
    (async () => {
      setIsLoading(true);
      await getInvoiceList(`${email}`, `${key}`, `${invoiceType}`)
      setModal(true);
      setIsLoading(false);
    })();
    setUser({ 'email': { email }, 'key': { key } })
  };

  useEffect(() => {
    if (dashboardInvoiceListing && dashboardInvoiceListing.data && dashboardInvoiceListing.data.length > 0) {
      const tableData = ['business', 'client_filled_date', 'client_filled_date', 'invoice_number', 'invoice_date', 'due_date', 'total_amount', 'pending_amount', 'invoice_pdf_link', 'expected_payment_date', 'invoice_tagging', 'invoice_owner_remarks'];

      const data = dashboardInvoiceListing.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => (
            (key === 'invoice_pdf_link') ?
              { [key]: <a href={element[key]}>Document Link</a> } : (key === 'invoice_tagging') ?
                { [key]: mapInvoice[element[key] - 1] } :
                { [key]: element[key] }
          )
          ),
          {
            Action: [
              {
                name: 'Add Invoice Data',
              }
            ]
          }
        )
      );
      const updatedList = dashboardInvoiceListing?.pending_invoices.map(item => {
        return { id: item.invoice_id, name: item.invoice_number };
      });
      
      setInvoiceNumberListObj(prevList => [...prevList, ...updatedList]);
      data && setListData(data);
    }
  }, [dashboardInvoiceListing]);

  const invoiceSubList = (type, invoice_id, check, invoice_number,currentItem=null) => {
    // if (check !== null) {
    //   return;
    // }
    if(type == "fee_type" && currentItem != null) {
       if(localStorage.getItem('currentRow') !== undefined) {
        localStorage.removeItem('currentRow');      
       }
       localStorage.setItem('currentRow',JSON.stringify(currentItem));
    } else {
       localStorage.removeItem('currentRow'); 
    }

    if(type == "fee_type" && !pendingInvoiceView){
      (async () => {
        if(invoice_id != null || invoice_id != undefined){
          await getLateFee(invoice_id);
          setFormData({
            ...formData,
            fee_type: LATE_FEE,
            amount: lateFee,
            invoice_id: invoice_id,
            invoice_number: invoice_number
          })
        }
      })();
    }
    setType(type);
    setFormData({ ...formData, type: type, invoice_id: invoice_id, invoice_number: invoice_number })
    setFormModal(true);
  }

  const downloadCSV = async () => {
    let list = [];
    list = Object.keys(dashboardSiteListing?.recon).map((email, index) => {
      return email
    })

    if(list != null && list != undefined) {
      setIsLoading(true);
      const res = await getCSV(list);
      if(res != false) {
         if(res?.response?.data?.data?.csv_link) {
            window.open(res?.response?.data?.data?.csv_link, '_blank');
         } else {
           toast.error('Some error occur while downloading the file.');
         }
         setIsLoading(false);
      } 
      setIsLoading(false);
   }
  }
  
  const handleSubmitData = (type) => {
    if(formData.fee_type !== null && formData.amount !== null){
      if(formData?.fee_type == LATE_FEE && formData?.amount > lateFee){
        toast.error(`Late Fee for this invoice cannot be more than ${lateFee}`);
      }else if(formData?.fee_type == COLLECTION_FEE && formData?.amount > COLLECTION_FEE_AMOUNT){
        toast.error(`Collection Fee for this invoice(s) cannot be more than ${COLLECTION_FEE_AMOUNT}`);
      }
      else{(async () => {
        setIsLoading(true);
        const res = await setInstallmentFee({...formData, invoice_id: [...new Set([...collectionFeeInvoiceList, formData?.invoice_id])]});
        setIsLoading(false);
        // console.log('ok status >> ' + res?.status);
        if (res?.status) {
          toast.success(res?.message);
          setFormData(inputs);
        } else {
          toast.error(res?.message);
        }
        setFormModal(false);
      })();
    }
    return
    }
    if (formData?.owner_remarks == 'Others - Please Specify') {
      if (formData?.remarkVal == '' || formData?.remarkVal == null || formData?.remarkVal == undefined) {
        toast.error('Please specify remarks');
        return;
      }
      const list = { formData };
      list['owner_remarks'] = remarks;
      setFormData(list);
    }
    var currentDate = new Date();
    var day = currentDate.getDate();
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    var formattedDate = day + '-' + month + '-' + year;
    if (formData?.expected_payment_date < formattedDate) {
      toast.error('Expected Payment Date must be greater than current date')
      return;
    }
    if (formData.type == null) {
      toast.error('Please fill all details!');
      return;
    }
    else if(formData?.type !== "fee_type") {
      (async () => {
        setIsLoading(true);
        const res = await saveInvoiceData(formData, type);
        setIsLoading(false);
        if (res) {
          toast.success('Saved Successfully');
          setFormData(inputs);

        } else {
          toast.error('Some error occurred. Please try again later.');
          return;
        }
      })();
      setFormModal(false);
      invoiceList(user.email.email, user.key.key);
    }
  }

  const getTitle = () => {
    switch (type) {
      case 'expected_payment_date':
        return 'Expected payment date';
      case 'invoice_tagging':
        return 'Tag invoices';
      case 'owner_remarks':
        return 'Owner remarks';
      case 'fee_type':
        return pendingInvoiceView?'Request for Collection/Late fee':'Request for Late fee';
      default:
        return 'User Input Data';  // default title
    }
  };

  useEffect(()=>{
    setIsLoading(true);
    if(formData?.fee_type == LATE_FEE){
      if(formData?.invoice_id != null || formData?.invoice_id!=undefined){
        (async () => {
          await getLateFee(formData?.invoice_id);
        })();
      }
      setFormData({...formData, amount: lateFee});
    }else if(formData?.fee_type == COLLECTION_FEE){
      setFormData({...formData, amount: COLLECTION_FEE_AMOUNT});
    }
    setIsLoading(false);
  },[formData?.fee_type])

  useEffect(() => {
    if(typeof lateFee === "number" && formData?.fee_type == LATE_FEE){
      setFormData({...formData, amount: lateFee});
    }
  },[lateFee])

  const getInvoiceListBySiteNo = async () => {
      const currentRow = JSON.parse(localStorage.getItem('currentRow'));
      const siteNumber = currentRow?.site_number;
      const userEmail = currentRow?.email;
      const clientId = currentRow?.client_id;
      // console.log('ROW >> ', currentRow);
      if(siteNumber !== undefined && userEmail !== undefined) {
          const invoices = await getInvoiceListBySiteNumber(userEmail,siteNumber,clientId);
          if(invoices) {
              //console.log(invoices);
              setMultiInvoice(invoices);
          }
      }
  }

  return (
    <Layout title={localization.baDashboard} isLoading={isLoading}>
      <div className="panel-card">
        <div className="card-body">
          {dashboardSiteListing?.my_site?.length !== 0 ? <>
            <h5 className="card-header">My Sites</h5>
            <div className="table-body mt-3">
              <div className="d-flex">
                <div className="col-table">
                  <table border="2" className="table table-bordered kmb nw-font dashboard-table">
                    <thead className="my-header__cls">
                      <tr>
                        <th className='td-style w-5'>No.</th>
                        <th>Site Type</th>
                        <th>Site Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardSiteListing?.my_site && dashboardSiteListing?.my_site.map((item, x) => {
                        { myData.push([item.project_type, item.project_count]) } return (
                          <>
                            <tr>
                              <td>{x + 1}</td>
                              <td>{item.project_type}</td>
                              <td>{item.project_count}</td>
                            </tr>
                          </>)
                      }
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="col-chart">
                  <Chart className='chart' chartType="PieChart" data={myData} options={options} height={"280px"} />
                </div>

              </div>
              <div className="col-table">
                <table border="2" className="table table-bordered kmb nw-font dashboard-table">
                  <thead>
                    <tr>
                      <th>Total Sites</th>
                      <th>Live Sites</th>
                      <th>Dismantled Sites</th>
                      <th>Disable Sites</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardSiteListing?.my_site_status &&
                      <>
                        <tr>
                          <td>{dashboardSiteListing?.my_site_total}</td>
                          <td>{Object.values(dashboardSiteListing?.my_site_status)[0] == undefined ? 0 : Object.values(dashboardSiteListing?.my_site_status)[0]}</td>
                          <td>{Object.values(dashboardSiteListing?.my_site_status)[1] == undefined ? 0 : Object.values(dashboardSiteListing?.my_site_status)[1]}</td>
                          <td>{Object.values(dashboardSiteListing?.my_site_status)[2] == undefined ? 0 : Object.values(dashboardSiteListing?.my_site_status)[2]}</td>
                        </tr>
                      </>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </> : <h5 className="card-header">No Sites found...</h5>}
        </div>
      </div>

      <div className="panel-card mt-4">
        <div className="card-body">
          {dashboardSiteListing?.subordinate_site?.length !== 0 ? <>
            <h5 className="card-header">Subordinate Sites</h5>
            <div className="table-body mt-3">
              <div className="d-flex">
                <div className="col-table">
                  <table border="2" className="table table-bordered kmb dashboard-table">
                    <thead>
                      <tr>
                        <th className='td-style w-5'>No.</th>
                        <th>Site Type</th>
                        <th>Site Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardSiteListing?.subordinate_site && dashboardSiteListing?.subordinate_site.map((item, x) => {
                        { mySubData.push([item.project_type, item.project_count]) } return (
                          <>
                            <tr>
                              <td>{x + 1}</td>
                              <td>{item.project_type}</td>
                              <td>{item.project_count}</td>
                            </tr>
                          </>)
                      }
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="col-chart">
                  <Chart className='chart' chartType="PieChart" data={mySubData} options={options} height={"280px"} />
                </div>
              </div>
              <div className="col-table">
                <table border="2" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th>Total Sites</th>
                      <th>Live Sites</th>
                      <th>Dismantled Sites</th>
                      <th>Disable Sites</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardSiteListing?.subordinate_site_status &&
                      <>
                        <tr>
                          <td>{dashboardSiteListing?.subordinate_site_total}</td>
                          <td>{Object.values(dashboardSiteListing?.subordinate_site_status)[0] == undefined ? 0 : Object.values(dashboardSiteListing?.subordinate_site_status)[0]}</td>
                          <td>{Object.values(dashboardSiteListing?.subordinate_site_status)[1] == undefined ? 0 : Object.values(dashboardSiteListing?.subordinate_site_status)[1]}</td>
                          <td>{Object.values(dashboardSiteListing?.subordinate_site_status)[2] == undefined ? 0 : Object.values(dashboardSiteListing?.subordinate_site_status)[2]}</td>
                        </tr>
                      </>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </> : <h5 className="card-header">No subordinate sites found...</h5>}
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-body">
          <div className="table table-body table-fixed">
            <div className="d-flex">
              <div className="col-12 ">
                <h5 className="card-header d-flex justify-content-between">Pending Invoice List<Button
                  onClick={() => downloadCSV()}
                  className="btn btn-primary"
                >CSV&nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z" />
                  </svg>
                </Button></h5>

                <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th width={20}>Mail</th>
                      <th>Date range</th>
                      <th>Invoice Count</th>
                      <th>Invoice Amount</th>
                      <th>Total Pendency</th>
                      <th>% Pendency</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardSiteListing?.my_site && Object.keys(dashboardSiteListing?.recon?.pendingInv).map((email, index) =>
                      <tr>
                        <td className='td-style' align='center' style={{ verticalAlign: 'middle' }} key="email">{email}</td>
                        <td><div>0 - 30 days</div><hr />
                          <div>31 - 60 days</div><hr />
                          <div>61 - 90 days</div><hr />
                          <div>90+ days</div>
                        </td>

                        <td key="invoice_count" className='text-center align-middle'>
                          {Object.keys(dashboardSiteListing?.recon?.pendingInv[email]).map((key) => (
                            <>
                              <div title='Click to view invoices' style={{ color: 'blue', cursor: 'pointer' }} onClick={() => invoiceList(email, key)}>
                                {dashboardSiteListing?.recon?.pendingInv[email][key]?.invoice_count}
                              </div>{key != 90 && <hr />}
                            </>
                          ))}
                        </td>

                        <td key="total_amount">
                          {Object.keys(dashboardSiteListing?.recon?.pendingInv[email]).map((key) => (
                            <><div>{dashboardSiteListing?.recon?.pendingInv[email][key]?.total_amount}</div>{key != 90 && <hr />}</>
                          ))}
                        </td>

                        <td key="total_outstanding">
                          {Object.keys(dashboardSiteListing?.recon?.pendingInv[email]).map((key) => (
                            <><div>{dashboardSiteListing?.recon?.pendingInv[email][key]?.total_outstanding}</div>{key != 90 && <hr />}</>
                          ))}
                        </td>

                        <td key="oustanding_percent">
                          {Object.keys(dashboardSiteListing?.recon?.pendingInv[email]).map((key) => (
                            <><div>{dashboardSiteListing?.recon?.pendingInv[email][key]?.outstanding_percent}</div>{key != 90 && <hr />}</>
                          ))}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="d-flex">
              <div className="col-12 ">
                <h5 className="card-header d-flex justify-content-between mt-5">Paid Invoice List</h5>
                <table border="1" className="table table-bordered kmb dashboard-table">
                  <thead>
                    <tr>
                      <th width={20}>Mail</th>
                      <th>Date range</th>
                      <th>Invoice Count</th>
                      <th>Invoice Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardSiteListing?.my_site && Object.keys(dashboardSiteListing?.recon?.paidInv).map((email, index) =>
                      <tr>
                        <td className='td-style' align='center' style={{ verticalAlign: 'middle' }} key="email">{email}</td>
                        <td>
                          <div>0 - 30 days</div><hr />
                          <div>31 - 60 days</div><hr />
                          <div>61 - 90 days</div>
                        </td>

                        <td key="invoice_count" className='text-center align-middle'>
                          {Object.keys(dashboardSiteListing?.recon?.paidInv[email]).map((key) => (
                            <>{key < 90 && <>
                              <div title='Click to view invoices' style={{ color: 'blue', cursor: 'pointer' }} onClick={() => invoiceList(email, key, "PAID")}>
                                {dashboardSiteListing?.recon?.paidInv[email][key]?.invoice_count}
                              </div>{key < 60 && <hr/>}</>}
                            </>
                          ))}
                        </td>

                        <td key="total_amount">
                          {Object.keys(dashboardSiteListing?.recon?.paidInv[email]).map((key) => (
                            <>{key < 90 && 
                            <><div>{dashboardSiteListing?.recon?.paidInv[email][key]?.total_amount}</div>{key < 60 && <hr />}</>}</>
                          ))}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-body">
          <div className="cbox">
            <div className="card-body">
              <div className="table-body">
                <h5 className="card-header">Feedback</h5>
                <div className="d-flex">
                  <div className="col-12 div-bp">
                    <table border="1" className="table table-bordered kmb dashboard-table">
                      <thead>
                        <tr>
                          <th>Rating out of 5</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='rw-clr'>
                          <td>
                            <div className='d-flex text-center'>
                              <div className="col-6 odd-line">Email</div>
                              <div className="col-6">Rating</div>
                            </div>
                          </td>
                        </tr>
                        {dashboardSiteListing?.feedback && dashboardSiteListing?.feedback.map((item) => {
                          return (<>
                            <tr>
                              <td>
                                <div className='d-flex text-center'>
                                  <div className="col-6 odd-line">
                                    {item.email}
                                  </div>
                                  <div className="col-6">{item.Feedback}</div>
                                </div>
                              </td>
                            </tr></>)
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-body">
          <div className="cbox">
            <div className="card-body">
              <div className="table-body">
                <h5 className="card-header">Minutes of Meeting</h5>
                <div className="d-flex">
                  <div className="col-12 div-bp">
                    <table border="1" className="table table-bordered kmb dashboard-table">
                      <thead>
                        <tr>
                          <th>MOM</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='rw-clr'>
                          <td>
                            <div className='d-flex text-center'>
                              <div className="col-6 odd-line">Total Meeting</div>
                              <div className="col-6">Total MOM Send</div>
                            </div>
                          </td>
                        </tr>
                        {dashboardSiteListing?.momData && dashboardSiteListing?.momData.map((item) => {
                          return (<>
                            <tr>
                              <td>
                                <div className='d-flex text-center'>
                                  <div className="col-6 odd-line">
                                    {item.total_meeting}
                                  </div>
                                  <div className="col-6">{item.total_mom_send}</div>
                                </div>
                              </td>
                            </tr></>)
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalPop
        title={'Invoice Data'}
        show={modal}
        handleModalHide={() => setModal(false)}
      >
        <div className="text-center">
          <div className="table table-body table-fixed w-auto">
            <div className="d-flex">
              <div className="col-12 ">
                <table style={{position:'relative'}} border="1" className="table table-bordered kmb nw-font dashboard-table">
                  <thead>
                    <tr className='cus-th-tr'>
                      <th>Business Name</th>
                      <th>Site Number</th>
                      <th>Client Name</th>
                      <th>Client Filled Date</th>
                      <th>Client Filled Payment Mode</th>
                      <th>Invoice Number</th>
                      <th>Invoice Date</th>
                      <th>Due Date</th>
                      <th>Total Amount</th>
                      <th>Pending Amount</th>
                      <th>Invoice Document</th>
                      {pendingInvoiceView && <>
                        <th>Expected Date</th>
                        <th>Map Invoices</th>
                        <th>Remarks</th>
                      </>}
                      <th>Perform Action</th>
                    </tr>
                  </thead>
                  {dashboardInvoiceListing?.data &&
                    <tbody>
                      {dashboardInvoiceListing?.data.map(item => 
                        <tr>
                          <td>{item.business}</td>
                          <td>{item.site_number}</td>
                          <td>{item.client}</td>
                          <td>{item.client_filled_date}</td>
                          <td>{item.client_filled_mode}</td>
                          <td>{item.invoice_number}</td>
                          <td>{item.invoice_date}</td>
                          <td>{item.due_date}</td>
                          <td>{item.total_amount}</td>
                          <td>{item.pending_amount}</td>
                          <td><a href={item.invoice_pdf_link}>Document Link</a></td>

                          {pendingInvoiceView && <>
                            <td title='Click to add Expected Date' style={{ cursor: 'pointer', textAlign: '-webkit-center' }} >
                              {item.expected_payment_date ?
                                  <>
                                    <td>{item.expected_payment_date}</td>
                                    <td><button aria-haspopup="true" aria-expanded="false" id="dropdown-basic" type="button" className="btn dropdown-val dropddown_align dropdown-toggle btn btn-primary" onClick={() => invoiceSubList("expected_payment_date", item.invoice_id, item.expected_payment_date)}>:</button></td>
                                  </>
                                  :
                                <button aria-haspopup="true" aria-expanded="false" id="dropdown-basic" type="button" className="btn dropdown-val dropddown_align dropdown-toggle btn btn-primary" onClick={() => invoiceSubList("expected_payment_date", item.invoice_id, item.expected_payment_date)}>:</button>}

                            </td>

                            <td title='Click to add Map Invoices' style={{ cursor: 'pointer', textAlign: '-webkit-center' }} onClick={() => invoiceSubList("invoice_tagging", item.invoice_id, item.invoice_tagging)}>{item.invoice_tagging != null ? mapInvoice[item.invoice_tagging - 1] : <button aria-haspopup="true" aria-expanded="false" id="dropdown-basic" type="button" className="btn dropdown-val dropddown_align dropdown-toggle btn btn-primary">:</button>}
                            </td>

                            <td title='Click to add Remarks' style={{ cursor: 'pointer', textAlign: '-webkit-center' }} onClick={() => invoiceSubList("owner_remarks", item.invoice_id, item.invoice_owner_remarks)}>{item.invoice_owner_remarks != null ? item.invoice_owner_remarks : <button aria-haspopup="true" aria-expanded="false" id="dropdown-basic" type="button" className="btn dropdown-val dropddown_align dropdown-toggle btn btn-primary">:</button>}</td>
                          </>}

                          {(item?.project_type === 'SOCIETY' && invoiceTypes.includes(item?.revenue_nature)) ?
                             <>
                             <td title='Click for action' style={{ cursor: 'pointer', textAlign: '-webkit-center' }} onClick={() => invoiceSubList("fee_type", item.invoice_id, LATE_FEE, item.invoice_number, item)}>{item.invoice_owner_remarks != null ? item.invoice_owner_remarks : <button aria-haspopup="true" aria-expanded="false" id="dropdown-basic" type="button" className="btn dropdown-val dropddown_align dropdown-toggle btn btn-primary">:</button>}</td>
                             </>
                             : <td>--</td>
                          }
              
                        </tr>
                      )}
                    </tbody>
                  }
                </table>
              </div>
            </div>
          </div>
        </div>
      </ModalPop>

      <ModalPop
        title={getTitle()}
        show={formModal}
        handleModalHide={() => {setFormData(inputs);setCollectionFeeInvoiceList([]);setFormModal(false)}}>

        {type === "expected_payment_date" &&
          // <FormSection title="Expected Payment Date">
          <>
            <DatePicker handleChange={(val) => { setFormData({ ...formData, expected_payment_date: val }); }} label="Expected Payment Date" required={false} />
            <Button className="btn-sm" onClick={() => handleSubmitData(type)}>{localization.submit}</Button>
          </>  
          // </FormSection>
        }


        {type === "invoice_tagging" &&
          // <FormSection title="Map Invoices">
          <>
            <DropDownInput
              label="Select invoicing"
              data={[
                {
                  id: 1,
                  name: "CN",
                },
                {
                  id: 2,
                  name: "Legal",
                },
                {
                  id: 3,
                  name: "Sales tagging",
                },
                {
                  id: 4,
                  name: "Adjustment for mapping of invoices",
                },
              ]}
              required
              errorMsg={localization.paymentMode}
              getIdValue={(val) => {
                setFormData({
                  ...formData,
                  invoice_tagging: val.id,
                });
              }}
              isStarRequired={true}
            />
            <Button className="btn-sm" onClick={() => handleSubmitData(type)}>{localization.submit}</Button>
            </>
          // </FormSection>
        }

        {type === "owner_remarks" &&
          // <FormSection title="Remarks">
          <>
            <DropDownInput
              label="Select invoicing"
              data={[
                {
                  id: 'Dispute between RWA',
                  name: "Dispute between RWA",
                },
                {
                  id: 'Service issue at site',
                  name: "Service issue at site",
                },
                {
                  id: 'Handover delay',
                  name: "Handover delay",
                },
                {
                  id: 'NCLT / Administrator site',
                  name: "NCLT / Administrator site",
                },
                {
                  id: 'Fund Issue',
                  name: "Fund Issue",
                },
                {
                  id: 'Tag not working',
                  name: "Tag not working",
                },
                {
                  id: 'Software services switched off',
                  name: "Software services switched off",
                },
                {
                  id: 'GST number no updated - Updation in GST required',
                  name: "GST number no updated - Updation in GST required",
                },
                {
                  id: 'Builder Site - Delay in payment',
                  name: "Builder Site - Delay in payment",
                }, {
                  id: 'Wrong Invoice - Billing details need to be corrected',
                  name: "Wrong Invoice - Billing details need to be corrected",
                },
                {
                  id: 'Others - Please Specify',
                  name: "Others - Please Specify",
                },
              ]}
              required
              errorMsg={localization.reason}
              getIdValue={(val) => {
                setFormData({
                  ...formData,
                  owner_remarks: val.id
                })
              }}
              isStarRequired={true}
            />
            {formData?.owner_remarks == 'Others - Please Specify' &&
              <TextAreaInput inputValue={formData?.remarkVal} className={`${!remarks && 'empty'} inline-css scrollbar-styling`} label="Remarks" type="text" rows={4} isStarRequired={true} errorMsg={localization.isRequired} handleChange={(e) => setFormData({
                ...formData,
                remarkVal: e.target.value
              })} required />
            }
            <Button className="btn-sm" onClick={() => {
              handleSubmitData(type)

            }}>{localization.submit}</Button>
            </>
          //</FormSection> 
        }

        {type === "fee_type" &&
        <>
            {pendingInvoiceView && 
             <DropDownInput
              label="Select fee type"
              data={[
                {
                  id: COLLECTION_FEE,
                  name: "Collection Fee",
                },
                {
                  id: LATE_FEE,
                  name: "Late Fee",
                }
              ]}
              required
              errorMsg={localization.reason}
              getIdValue={(val) => {
                setFormData({
                  ...formData,
                  fee_type: val.id
                });
                getInvoiceListBySiteNo();
              }}
              isStarRequired={true}
            />}
            {formData?.fee_type == COLLECTION_FEE &&<>
              <DropDownInput
                multipule={true}
                data={multiInvoice}
                label="Select invoices..."
                getIdValue={(val) => {
                  if(Array.isArray(val)){
                    setCollectionFeeInvoiceList(val.map((obj) => obj.id))
                  }
                }}
              />
              <ConstantInput
                value={formData.amount}
                label={localization.amount}
                regex={Regex.number.test(formData.amount)}
                errorMsg={localization.isRequired}
                type="number"
                required={true}
                isStarRequired={true}
                handleChange={(value) =>
                  setFormData({ ...formData, amount: value })
                }
              />
              </>
            }
            {formData?.fee_type == LATE_FEE &&<>
              <DivLayout
                heading="Invoice Number - "
                data={formData?.invoice_number}
                status={true}
              />
              <ConstantInput
                value={formData.amount}
                label={localization.amount}
                regex={Regex.number.test(formData.amount)}
                errorMsg={localization.isRequired}
                type="number"
                required={true}
                isStarRequired={true}
                handleChange={(value) =>
                  setFormData({ ...formData, amount: value })
                }
              />
            </>
              
            }
              <TextAreaInput
                inputValue={formData?.remarkFee}
                className={`empty inline-css scrollbar-styling`}
                label="Remarks" type="text" rows={2}
                handleChange={(e) =>
                  setFormData({
                  ...formData,
                  remarkFee: e.target.value
                })}
             />
            <Button className="btn-sm" onClick={() => {
              handleSubmitData(type)

            }}>{localization.submit}</Button>
            </>
        }
       
      </ModalPop>
    </Layout>
  )
}

export default Dashboard
